import { Injectable } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { HTTPService } from './http.service';

@Injectable({
  providedIn: 'root'
})
export class UploadServices {

  sub:Subscription;

  public progress:BehaviorSubject<number> = new BehaviorSubject(0)

  constructor(private http:HTTPService) { 
      this.sub = this.http.progress.subscribe(number=>{
          this.progress.next(number);
      })

  }

  ngOnDestroy(){
    if (this.sub!= null ) {this.sub.unsubscribe();}
  }

  upLoadFile( data, ignoreerror:Boolean = false ){
    return this.http.postFile(data,"JsonBrokerServices/uploadfile",false,true,ignoreerror);
  }

  upLoadFileTempory( data, ignoreerror:Boolean = false ){
    return this.http.postFile(data,"JsonBrokerServices/uploadfiletemporary",false,true,ignoreerror);
  }

   upLoadFileFlex( data, url, ignoreerror:Boolean = false ){
    return this.http.postFile(data,url,false,true,ignoreerror);
  }
}
